import { Drawer, Layout, Grid } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import LayoutHeader from "src/features/layout/LayoutHeader";
import MainMenu, { menuRouteMap } from "src/features/layout/MainMenu";
import { useScreenStore } from "src/stores/screenStore";
import { useOverlayBackKey } from "src/hooks/useOverlayBackKey";
import PortfolioPet from "src/features/dashboard/PortfolioPet";

const { Content, Sider, Footer } = Layout;

const Default = () => {
  const isMounted = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const screens = useScreenStore((s) => s.screens);

  const [menuCollapsed, setMenuCollapsed] = useState<boolean>(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  // 백키로도 모바일 메뉴 드로어가 닫히도록
  useOverlayBackKey(mobileDrawerOpen, () => setMobileDrawerOpen(false));
  const [selectedMenu, setSelectedMenu] = useState<string>("");
  const [openedMenu, setOpenedMenu] = useState<string[]>([]);

  useEffect(() => {
    isMounted.current = true;
  }, []);

  // URL → 메뉴 상태 동기화
  const updateMenuState = useCallback(
    (pathname: string) => {
      if (!isMounted.current) return;
      const segments = pathname.replace(/^\//, "").split("/");
      // /investment/portfolio → 부모(investment) + 마지막 세그먼트(menu key)
      const last = segments[segments.length - 1];
      let menuKey = "";
      let parentKey = "";
      for (const [key, path] of Object.entries(menuRouteMap)) {
        const pathSegments = path.replace(/^\//, "").split("/");
        if (pathSegments[pathSegments.length - 1] === last && pathSegments[0] === segments[0]) {
          menuKey = key;
          parentKey = pathSegments[0];
          break;
        }
      }
      if (menuKey) {
        setSelectedMenu(menuKey);
        setOpenedMenu((prev) => (prev.includes(parentKey) ? prev : [...prev, parentKey]));
      } else if (pathname === "/" || pathname === "/dashboard") {
        setSelectedMenu("dashboard");
      }
    },
    [],
  );

  useEffect(() => {
    updateMenuState(location.pathname);
  }, [location.pathname, updateMenuState]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LayoutHeader onMenuClick={() => setMobileDrawerOpen(true)} />
      <Layout>
        {/* 데스크톱 사이드바 */}
        <Sider
          collapsible
          collapsed={menuCollapsed}
          onCollapse={setMenuCollapsed}
          width={200}
          style={{
            display: screens.md ? "block" : "none",
            background: "var(--app-color-bg-container)",
          }}
        >
          <MainMenu selectedKeys={[selectedMenu]} openKeys={openedMenu} onOpenChange={setOpenedMenu} />
        </Sider>

        {/* 모바일 Drawer */}
        <Drawer
          placement="left"
          open={mobileDrawerOpen}
          onClose={() => setMobileDrawerOpen(false)}
          width={240}
          styles={{ body: { padding: 0 } }}
        >
          <MainMenu selectedKeys={[selectedMenu]} openKeys={openedMenu} onOpenChange={setOpenedMenu} onNavigate={() => setMobileDrawerOpen(false)} />
        </Drawer>

        <Content style={{ minHeight: 280 }}>
          <Outlet />
        </Content>
      </Layout>
      <Footer className="app-footer" style={{ textAlign: "center", fontSize: 12, color: "#888" }}>
        FinHub ©{new Date().getFullYear()}
      </Footer>
      {/* 포트폴리오 펫 (폴리) — 모든 화면 하단 우측 플로팅 */}
      <PortfolioPet />
    </Layout>
  );
};

export default Default;
